import type { FC } from 'react';
import { Icon } from '~/components/ui/icon';
import { toLocaleDateString } from '~/utils/date';

interface BlogHeaderProps {
  title?: string;
  date?: string;
}

const BlogHeader: FC<BlogHeaderProps> = ({ title, date }) => {
  return (
    <div className="mb-8">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{title}</h1>
      <div className="flex items-center text-sm text-gray-600 space-x-4">
        <time className='flex items-center gap-2'><Icon name="material-symbols:calendar-month" className="w-4 h-4" />{toLocaleDateString(new Date(date || ''))}</time>
      </div>
    </div>
  );
};

export default BlogHeader;